export default "__VITE_ASSET__Chl67ws0__"